const PROTOCOLO = window.location.protocol;
const HOST = window.location.hostname;
const PORT = window.location.port >= 8080 ? 80 : window.location.port;

export default {
    PROTOCOLO,
    HOST,
    PORT
}
